import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CchReceviedComplaintComponent } from '../cch-recevied-complaint/cch-recevied-complaint.component';
import { CchSendComplaintComponent } from '../cch-send-complaint/cch-send-complaint.component';
import { ComplaintsService } from '../../../../services/Complaints-Service/complaints.service';
import { ToastAlertService } from '../../../../services/toast-alert/toast-alert.service';
import { LoadingSpinnerComponent } from '../../../../components/loading-spinner/loading-spinner.component';
import { SerchableDropdownComponent } from '../../../../components/serchable-dropdown/serchable-dropdown.component';

@Component({
  selector: 'app-cch-view-complaint',
  standalone: true,
  imports: [CommonModule, FormsModule, CchReceviedComplaintComponent, CchSendComplaintComponent, SerchableDropdownComponent, LoadingSpinnerComponent],
  templateUrl: './cch-view-complaint.component.html',
  styleUrl: './cch-view-complaint.component.css'
})
export class CchViewComplaintComponent implements OnInit {
  isSelectRecevied: boolean = true;
  isSelectSent: boolean = false;
  isAddComplaintOpen: boolean = false;
  categoryArr: Category[] = [];

  category: string = '';
  complaint: string = '';


  isLoading: boolean = false;

  constructor(
    private complaintsService: ComplaintsService,
    private toastSrv: ToastAlertService
  ) { }

  ngOnInit(): void {
    this.fetchAllCategory();
  }

  get categoryDropdownItems() {
    return this.categoryArr.map(cat => ({
      value: cat.id.toString(),
      label: cat.categoryEnglish,
      disabled: false
    }));
  }

  // 5. Add selection change handler
  onCategorySelectionChange(selectedValue: string) {
    this.category = selectedValue || '';
  }

  onSubmit() {
    if (this.category === '' || this.complaint.trim() === '') {
      this.toastSrv.warning('Please fill out all fields.')
      return;
    }

    this.isLoading = true;

    const formData = {
      category: this.category,
      complaint: this.complaint,
    };

    this.complaintsService.submitCCHComplaint(formData).subscribe(
      (response) => {
        if (response.status) {
          this.toastSrv.success('Your complaint was submitted');
          this.isAddComplaintOpen = false;
          this.category = '';
          this.complaint = '';
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.toastSrv.warning('Please try again')
        }
        this.isLoading = false;

      },
      (error) => {
        this.isLoading = false;
        console.error('Error submitting complaint:', error);
        this.toastSrv.error('An error occurred while submitting your complaint. Please try again.');
      }
    );
  }

  selectRecevied() {
    this.isSelectRecevied = true;
    this.isSelectSent = false;
  }

  selectSent() {
    this.isSelectRecevied = false;
    this.isSelectSent = true;
  }

  closeAddComplaint() {
    this.isAddComplaintOpen = false;
    this.category = '';
    this.complaint = '';
  }

  openAddComplaint() {
    this.isAddComplaintOpen = true;
  }


  fetchAllCategory() {
    this.complaintsService.getComplainCategory().subscribe(
      (res) => {
        this.categoryArr = res;
      }
    )
  }

  onTrimInput(event: Event): void {
    const inputElement = event.target as HTMLTextAreaElement;
    const trimmedValue = inputElement.value.trimStart();
    this.complaint = trimmedValue;
    inputElement.value = trimmedValue;
  }


  capitalizeFirstLetter(event: Event) {
    if (this.complaint) {
      // Trim spaces
      this.complaint = this.complaint.trim();

      // Capitalize first letter
      this.complaint =
        this.complaint.charAt(0).toUpperCase() +
        this.complaint.slice(1);
    }
  }


}

class Category {
  id!: number;
  categoryEnglish!: string
}
